"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Disclaimer_1 = __importDefault(require("../Disclaimer"));

var Disclaimers_meta_1 = require("./Disclaimers.meta");

var Disclaimers =
/** @class */
function (_super) {
  __extends(Disclaimers, _super);

  function Disclaimers(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Disclaimers_meta_1.DISCLAIMERS_CATEGORY_KEY;
    _this.componentKey = Disclaimers_meta_1.DISCLAIMERS_COMPONENT_KEY;
    return _this;
  }

  Disclaimers.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        disclaimers = _a.disclaimers,
        hasHtmlContent = _a.hasHtmlContent,
        separator = _a.separator,
        defaultProps = _a.defaultProps;

    if (ksys_app_template_1.utils.typeChecks.isNullOrEmpty(disclaimers)) {
      return null;
    }

    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, disclaimers.length > 0 && disclaimers.map(function (disclaimer, index) {
      var disclaimerProps = __assign(__assign(__assign({
        separator: separator,
        hasHtmlContent: hasHtmlContent
      }, defaultProps), disclaimer), {
        useSeparator: index < disclaimers.length - 1
      });

      return react_1.default.createElement(Disclaimer_1.default, __assign({
        key: "disclaimer-" + index
      }, disclaimerProps));
    }));
  };

  Disclaimers = __decorate([mobx_react_1.observer], Disclaimers);
  return Disclaimers;
}(shared_1.ComponentBase);

exports.Disclaimers = Disclaimers;
exports.default = shared_1.InjectedStyledComponent(Disclaimers, Disclaimers_meta_1.DISCLAIMERS_CATEGORY_KEY, Disclaimers_meta_1.DISCLAIMERS_COMPONENT_KEY);